let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("4vLaG"), load("3R6XQ"), load("jZrXm"), load("jCj3D")]).then(() => parcelRequire('3Zv9U'));